/* Roy Riff — PDP: cambio de variante (precio + cuotas + galería) sin recargar */
(function () {
  const root = document.querySelector('[data-rr-product]');
  if (!root) return;

  let variants = [];
  try {
    variants = JSON.parse(root.dataset.productJson);
  } catch (e) {
    return;
  }

  const form = document.getElementById('rr-product-form');
  const priceEl = root.querySelector('[data-rr-price]');
  const idInput = root.querySelector('[data-rr-variant-id]');
  const addBtn = root.querySelector('[data-rr-add]');
  const cuotasBox = root.querySelector('[data-rr-cuotas]');
  const galleryMain = root.querySelector('[data-rr-gallery-main]');
  const thumbs = root.querySelector('[data-rr-thumbs]');

  const money = (cents) => {
    return '$' + (cents / 100).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  function selectedOptions() {
    return Array.from(form.querySelectorAll('input[data-rr-option]:checked')).map((i) => i.value);
  }

  function findVariant() {
    const opts = selectedOptions();
    return variants.find((v) => opts.every((o, idx) => v.options[idx] === o));
  }

  function updateCuotas(price) {
    if (!cuotasBox) return;
    cuotasBox.querySelectorAll('[data-rr-cuota]').forEach((el) => {
      // 25/09: con custom.rr_precios el valor final es por bici y no depende del color:
      // no se recalcula (data-rr-fixed). Sólo el esquema viejo (coeficiente) se recalcula.
      if ('rrFixed' in el.dataset) return;
      const coef = parseInt(el.dataset.coef, 10) || 100;
      const n = parseInt(el.dataset.n, 10) || 1;
      el.textContent = money(Math.round((price * coef) / 100 / n));
    });
    // El precio en efectivo/transferencia es un monto fijo por bici (data-rr-transfer-fixed):
    // nunca se recalcula ni se expresa como porcentaje.
  }

  function onOptionChange() {
    const variant = findVariant();
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    updateCuotas(variant.price);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addBtn.dataset.label || addBtn.textContent : 'Agotada — consultanos';
      if (!addBtn.dataset.label && variant.available) addBtn.dataset.label = addBtn.textContent;
    }
    if (variant.featured_image && galleryMain) {
      const img = galleryMain.querySelector('img');
      if (img) {
        img.src = variant.featured_image.src;
        img.removeAttribute('srcset');
      }
    }
    document.dispatchEvent(new CustomEvent('rr:variant', { detail: variant }));
  }

  form && form.addEventListener('change', (e) => {
    if (e.target.matches('input[data-rr-option]')) onOptionChange();
  });

  /* --- Barra sticky de compra (mobile) ---------------------------------- */
  const sticky = document.querySelector('[data-rr-sticky]');
  if (sticky) {
    const stickyPrice = sticky.querySelector('[data-rr-sticky-price]');
    const stickyCuota = sticky.querySelector('[data-rr-sticky-cuota]');
    const buyBox = root.querySelector('.rr-product-hero__buy');

    // El plan DESTACADO (6 cuotas), no el primero de la lista
    const featured =
      (cuotasBox && cuotasBox.querySelector('[data-rr-featured]')) ||
      (cuotasBox && cuotasBox.querySelector('[data-rr-cuota]'));

    const syncSticky = (price) => {
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (stickyCuota && featured) {
        const n = parseInt(featured.dataset.n, 10) || 1;
        if ('rrFixed' in featured.dataset) {
          // Valor final por bici: la cuota es la que ya imprimió Liquid. Nunca "sin interés".
          stickyCuota.textContent = `${n} cuotas de ${featured.textContent.trim()}`;
        } else {
          const coef = parseInt(featured.dataset.coef, 10) || 100;
          stickyCuota.textContent = `${n} cuotas de ${money(Math.ceil((price * coef) / 100 / n))}`;
        }
      }
    };
    syncSticky((variants.find((v) => v.available) || variants[0]).price);

    // Mostrar la barra cuando el botón principal quedó arriba del viewport.
    // Un centinela + IntersectionObserver es más confiable que escuchar scroll:
    // funciona con scroll suave, anclas y cambios de layout.
    if (buyBox) {
      const setVisible = (on) => {
        if (on) sticky.removeAttribute('hidden');
        else sticky.setAttribute('hidden', '');
      };
      const check = () => setVisible(buyBox.getBoundingClientRect().bottom < 0);

      const sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;height:1px;width:1px;pointer-events:none;';
      buyBox.insertAdjacentElement('afterend', sentinel);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(check, { threshold: [0, 1] }).observe(sentinel);
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }

    document.addEventListener('rr:variant', (e) => syncSticky(e.detail.price));
  }

  thumbs && thumbs.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-full]');
    if (!btn) return;
    thumbs.querySelectorAll('button').forEach((b) => b.removeAttribute('aria-current'));
    btn.setAttribute('aria-current', 'true');
    const img = galleryMain.querySelector('img');
    if (img) {
      img.src = btn.dataset.full;
      img.removeAttribute('srcset');
    }
  });
})();
